export default "__VITE_ASSET__BafWhdL8__"